export const value: string[] = ['0.0941', '0.0937', '0.0913'];
